import * as React from 'react';
import classnames from 'classnames';
import { useDropdownContext } from '../../context/ButtonDropdownContext.js';
import { ButtonDropdownIcon } from '../ButtonDropdownIcon/ButtonDropdownIcon.js';

const ButtonDropdownButton = ({ children , className , 'data-t': dataT , id  })=>{
    const { isOpen , toggle , floatingProps: { floatingContext: { refs  } ,  } , contentId , isDisabled , 'aria-label': ariaLabel ,  } = useDropdownContext();
    const buttonClassnames = classnames('button-dropdown__button', className, {
        'button-dropdown__button--is-open': isOpen,
        'button-dropdown__button--disabled': isDisabled
    });
    return /*#__PURE__*/ React.createElement("button", {
        "aria-controls": contentId,
        "aria-expanded": isOpen,
        "aria-haspopup": "true",
        "aria-label": ariaLabel,
        className: buttonClassnames,
        "data-t": dataT,
        disabled: isDisabled,
        id: id,
        onClick: toggle,
        ref: refs.setReference,
        type: "button"
    }, children, /*#__PURE__*/ React.createElement(ButtonDropdownIcon, null));
};

export { ButtonDropdownButton };
//# sourceMappingURL=ButtonDropdownButton.js.map
